import React, { useEffect } from "react";
import { get, isEmpty } from "lodash";
import SelectField from "Components/formControls/HookFields/SelectField";
import { checkArrayLength } from "src/utils";
import { checkinDetailSelector } from "Recoil/Checkins/selector";
import { useRecoilValue } from "recoil";

const UserFilter = ({
  allCheckinRatees,
  skillRatee,
  setSkillRatee,
  handleOrangeDot,
}) => {
  const checkinDetails = useRecoilValue(checkinDetailSelector);
  const { checkInType } = checkinDetails;

  const handleChange = (e) => {
    const { value } = get(e, "target");
    setSkillRatee(allCheckinRatees.find((f) => f.userid === value));
    if (checkInType !== "SKILLRATING") {
      handleOrangeDot(value);
    }
  };

  const handleOnClick = (e) => {
    if(e?.detail === 1 && e?.target?.dataset) {
      handleOrangeDot?.(e?.target?.dataset.value);
    }
  };

  useEffect(() => {
    if (
      checkArrayLength(allCheckinRatees) &&
      !allCheckinRatees.find((res) => res.userid === skillRatee.userid)
    ) {
      setSkillRatee(allCheckinRatees?.[0]);
    }
  }, [allCheckinRatees, skillRatee]);

  return (
    !isEmpty(allCheckinRatees) && (
      <div className="user-filter">
        <SelectField
          onClick={handleOnClick}
          key={skillRatee?.userid}
          users={allCheckinRatees || []}
          onChange={(e) => handleChange(e)}
          value={skillRatee?.userid}
          showIndicator={allCheckinRatees?.some((res) => res?.isNewHighlight)}
        />
      </div>
    )
  );
};

export default UserFilter;
